import React, { lazy, useState } from 'react';
import ContractHistory from './ContractHistory';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const TopActions = ({ i18n, paymentInformation, Styled }) => {
  const [open, setOpen] = useState(false);

  const clickedModal = (e) => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <Styled.Wrapper>
      <div className="contractWrapper">
        <FormStyle.TextWrapper>
          <span
            className={`${checkServiceProvider('contractExpiry', window.$environment.SERVICE_PROVIDER, false)} contractExpiry`}
          >
            {i18n.t('paymentInformation.contractExpiry')} :
          </span>
          {paymentInformation?.contractExpirationDate}
        </FormStyle.TextWrapper>
        <FormStyle.ButtonsWrapper className="contractButtons">
          <Button
            type="submit"
            className="buttonStyle"
            label={i18n.t('paymentInformation.contractHistory')}
            onClick={() => {
              clickedModal();
            }}
          />
        </FormStyle.ButtonsWrapper>
      </div>

      <Modal
        open={open}
        setOpen={setOpen}
        data={{
          header: '',
          content: () => {
            return (
              <ContractHistory contractHistoryList={paymentInformation?.contractHistoryDtos || []} Styled={Styled} i18n={i18n} />
            );
          },
        }}
        onCloseModal={closeModal}
        background="black"
        withCloseIcon
        contractHistory
        width={720}
      />
    </Styled.Wrapper>
  );
};
export default TopActions;
